import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MailCheck, MailWarning } from "lucide-react";

export const DoneStep = ({ booking }) => (
  <div className="flex min-h-[70vh] flex-col justify-center py-10" data-testid="booking-confirmation">
    <p className="eyebrow mb-6 text-acid">Booking received · {booking?.reference}</p>
    <h1 className="font-display text-[18vw] uppercase leading-[0.86] text-zinc-50 sm:text-[11vw] lg:text-[8rem]">
      {["Consider it", "handled."].map((l, i) => (
        <span key={l} className="block overflow-hidden">
          <motion.span className={`block ${i === 1 ? "font-serif-i normal-case text-acid" : ""}`} initial={{ y: "105%" }} animate={{ y: 0 }}
            transition={{ duration: 1, delay: 0.1 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}>{l}</motion.span>
        </span>
      ))}
    </h1>
    <p className="mt-8 max-w-xl text-lg text-zinc-300">
      {booking?.service_name} on {booking?.date} at {booking?.time_label}. We&apos;ll review and confirm shortly.
    </p>
    <p className="mt-4 flex items-center gap-2 text-sm text-zinc-400" data-testid="booking-email-status">
      {booking?.email_status === "sent"
        ? <><MailCheck className="h-4 w-4 text-acid" /> Confirmation sent to {booking?.email}</>
        : <><MailWarning className="h-4 w-4 text-amber-400" /> We couldn&apos;t send the email right now, but your booking is saved.</>}
    </p>
    <Link to="/" className="mt-10 w-fit rounded-full border border-white/20 px-6 py-3 text-sm font-semibold transition-colors hover:border-[var(--acid)] hover:text-[var(--acid)]" data-testid="booking-back-home-button">
      Back to home
    </Link>
  </div>
);
